<div role="tabpanel" class="tab-pane" [class.active]="active">
  <ng-content></ng-content>
</div>
